/*
LocalStorage keys
*/
export const storage = {
    theme: '__theme_color',
    leftSidebar: '__left_sidebar',
    tokenName: '',
    dashboardLayout: '__dashboard_layout',
    batchSelect: '__batch_select',
}

// Toaster
export const defaultToaster = {
    toasterType: "OK",
    title: '',
    message: '',
    counter: 0
}

export const defaultLeftSidebar = ''

//fetch state
export const initialFetchState = {
    data: {},
    isFetching: false,
    shouldReload: false,
    errors: {},
    message: '',
    reduxStructure: true
}

//enum fetch Item state
export const initialEnumItemFetchState = {
    data: [],
    isFetching: false,
    shouldReload: false
}

//user state
export const initialUserFetchState = {
    isAuthenticated: false,
    isFetching: false,
    user: {},
}

export const initialCallData = {
    callAvailability: false,
    data: {}
}

